import { render, staticRenderFns } from "./d-sticky-menu.vue?vue&type=template&id=4e08ed77&"
import script from "./d-sticky-menu.vue?vue&type=script&lang=js&"
export * from "./d-sticky-menu.vue?vue&type=script&lang=js&"
import style0 from "./d-sticky-menu.vue?vue&type=style&index=0&id=4e08ed77&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports